<template>
  <layout-vertical>
    <router-view />
    <div
      slot="vertical-menu-header"
      class="header-title"
      @click="navigateToHomepage"
    >
      <!-- <img style="max-width:84%;" src="/images/kp-logo.png" alt="Kunskapsportföljens logotyp" > -->
      <img style="height: 40px;" :src="logo" alt="RättVisat logotyp" />
      <h1 class="font-medium-5 mb-0 text-primary">
        RättVisat
      </h1>
    </div>
    <template #navbar="{ toggleVerticalMenuActive }">
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>
    <div slot="breadcrumb">
      <ViewUserAlert />
    </div>

    <div slot="footer">
      <p class="text-center text-muted">
        <small
          >Copyright@{{ new Date().getFullYear() }}.
          <a
            href="https://brackediakoni.se/bracke-innovation/e-halsa/rattvisat/"
            >Bräcke diakoni</a
          >
        </small>
      </p>
    </div>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-vertical>
</template>

<script>
import LayoutVertical from "@core/layouts/layout-vertical/LayoutVertical.vue";
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from "@/layouts/components/Navbar.vue";
//import AppBreadcrumb from '../components/AppBreadcrumb'
import Formatter from "@/functions/Formatter";
import ViewUserAlert from "../components/ViewUserAlert.vue";
import RattVisatLogo from "../../assets/images/icons/login/RattVisatLogo.svg";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      logo: RattVisatLogo,
      homepage: "",
    };
  },
  components: {
    LayoutVertical,
    Navbar,
    ViewUserAlert,
  },

  mounted() {
    this.$nextTick(async () => {
      this.homepage = await this.fetchHomepage(this.$currentUserId());
      this.homepage = "/" + this.homepage.url;
    });
  },
  computed: {
    ...mapGetters(["getAllPortfolios", "getActivePortfolio"]),

    getPortfolios: function() {
      let portfolios = this.getAllPortfolios.filter((p) => p.owner.id);
      let illegalPortfolios = [];
      portfolios.forEach((p) => {
        if (p.owner.id === this.getCurrentUserId) {
          illegalPortfolios.push(p.id);
          return;
        }

        if (p.owner.Avatar) {
          p.owner.avatar = Formatter.formatImage(p.owner.Avatar);
        }
      });
      return portfolios.filter((p) => !illegalPortfolios.includes(p.id));
    },
  },

  methods: {
    ...mapActions(["fetchHomepage"]),
    ...mapActions("userAccount", ["fetchUserById"]),

    async navigateToHomepage() {
      const potfolios = this.getPortfolios;
      const activePortfolio = this.getActivePortfolio;

      if (potfolios.length > 0 && activePortfolio) {
        let homepage = await this.fetchHomepage(this.$currentUserId());
        homepage = "/" + homepage.url;

        if (homepage != this.$route.path) {
          this.$router.push(homepage);
        }
      }
    },
  },
};
</script>

<style>
.header-title {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 10px;
  margin-top: 10px;
  cursor: pointer;
}
</style>
